import { Component, HostListener, ViewChild, ElementRef } from "@angular/core";

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent {


  @ViewChild('widgetsContent') widgetsContent: ElementRef;

  ngOnInit() {

  }


  scrollLeft(cardWidth) {
     ;

    this.widgetsContent.nativeElement.scrollLeft -= 433;
  }
  scrollRight(cardWidth) {
     ;

    this.widgetsContent.nativeElement.scroll += 433;
  }
}
